(function () {
  var sections = [];
  var ticking = false;
  var rebuildTimer = null;
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function shouldReduceMotion() {
    return !!(prefersReducedMotion && prefersReducedMotion.matches);
  }

  function buildLine() {
    var line = document.createElement('span');
    line.className = 'cd-pdp-line';
    line.setAttribute('aria-hidden', 'true');
    return line;
  }

  function buildInner(text) {
    var inner = document.createElement('span');
    inner.className = 'cd-pdp-line__text';
    inner.textContent = text;
    return inner;
  }

  function splitRenderedLines(node, text) {
    var words = text.split(/\s+/).filter(Boolean);
    if (!words.length) return text ? [text] : [];

    var nodeWidth = Math.round(node.getBoundingClientRect().width || node.offsetWidth || 0);
    if (nodeWidth <= 2) return [text];

    var measure = document.createElement(node.tagName || 'span');
    var computed = window.getComputedStyle(node);

    measure.style.position = 'absolute';
    measure.style.left = '-99999px';
    measure.style.top = '0';
    measure.style.visibility = 'hidden';
    measure.style.pointerEvents = 'none';
    measure.style.width = nodeWidth + 'px';
    measure.style.maxWidth = 'none';
    measure.style.whiteSpace = 'normal';
    measure.style.font = computed.font;
    measure.style.fontFamily = computed.fontFamily;
    measure.style.fontSize = computed.fontSize;
    measure.style.fontWeight = computed.fontWeight;
    measure.style.letterSpacing = computed.letterSpacing;
    measure.style.lineHeight = computed.lineHeight;
    measure.style.textTransform = computed.textTransform;
    measure.style.textAlign = computed.textAlign;

    document.body.appendChild(measure);

    var spans = words.map(function (word, index) {
      var span = document.createElement('span');
      span.textContent = index === words.length - 1 ? word : word + ' ';
      span.style.display = 'inline-block';
      span.style.whiteSpace = 'pre';
      measure.appendChild(span);
      return span;
    });

    var lines = [];
    var current = [];
    var currentTop = null;

    spans.forEach(function (span) {
      var top = span.offsetTop;
      if (currentTop === null) currentTop = top;
      if (Math.abs(top - currentTop) > 2 && current.length) {
        lines.push(current.join('').trim());
        current = [];
        currentTop = top;
      }
      current.push(span.textContent || '');
    });

    if (current.length) lines.push(current.join('').trim());
    measure.remove();
    return lines.length ? lines : [text];
  }

  function buildLineflow(root) {
    if (!root) return;

    root.querySelectorAll('[data-cd-pdp-lineflow]').forEach(function (node) {
      var original = node.getAttribute('data-cd-pdp-original');
      if (!original) {
        original = (node.innerHTML || '').trim();
        node.setAttribute('data-cd-pdp-original', original);
      }

      var segments = original
        .replace(/<br\s*\/?>/gi, '\n')
        .split('\n')
        .map(function (part) {
          return part.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
        })
        .filter(Boolean);

      if (!segments.length) {
        segments = [(node.textContent || '').replace(/\s+/g, ' ').trim()];
      }

      node.setAttribute('aria-label', segments.join(' '));
      node.innerHTML = '';

      var lineIndex = 0;
      segments.forEach(function (segment) {
        splitRenderedLines(node, segment).forEach(function (lineText) {
          var line = buildLine();
          line.style.setProperty('--cd-pdp-line-index', String(lineIndex));
          line.appendChild(buildInner(lineText));
          node.appendChild(line);
          lineIndex += 1;
        });
      });
    });
  }

  function markVisible(node) {
    if (!node) return;
    node.classList.add('is-visible');
  }

  function syncVideoControls(entry) {
    if (!entry || !entry.featureVideo) return;

    if (entry.playButton) {
      var isPaused = entry.featureVideo.paused;
      entry.playButton.setAttribute('data-state', isPaused ? 'paused' : 'playing');
      entry.playButton.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      entry.playButton.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
    }

    if (entry.muteButton) {
      var isMuted = entry.featureVideo.muted;
      entry.muteButton.setAttribute('data-state', isMuted ? 'muted' : 'audible');
      entry.muteButton.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
      entry.muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
    }
  }

  function prepareFeatureVideo(entry) {
    if (!entry || !entry.featureVideo) return;

    if (!entry.videoPrepared) {
      entry.featureVideo.muted = true;
      entry.featureVideo.defaultMuted = true;
      entry.videoPrepared = true;
    }

    entry.featureVideo.loop = true;
    entry.featureVideo.autoplay = true;
    entry.featureVideo.playsInline = true;
    entry.featureVideo.setAttribute('muted', '');
    entry.featureVideo.setAttribute('loop', '');
    entry.featureVideo.setAttribute('autoplay', '');
    entry.featureVideo.setAttribute('playsinline', '');
    entry.featureVideo.setAttribute('webkit-playsinline', '');
  }

  function playFeatureVideo(entry) {
    if (!entry || !entry.featureVideo || entry.userPausedVideo) return;

    prepareFeatureVideo(entry);

    if (!entry.featureVideo.paused) {
      syncVideoControls(entry);
      return;
    }

    var playPromise = entry.featureVideo.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise
        .then(function () {
          syncVideoControls(entry);
        })
        .catch(function () {
          syncVideoControls(entry);
        });
    } else {
      syncVideoControls(entry);
    }
  }

  function resetAccordionPanel(item, panel) {
    if (!item || !panel) return;
    panel.style.height = '';
    panel.style.opacity = '';
    panel.style.overflow = '';
    item.classList.remove('is-opening', 'is-closing');
  }

  function setAccordionItemState(item, shouldOpen) {
    if (!item) return;

    var panel = item.querySelector('[data-cd-pdp-accordion-panel]');
    var summary = item.querySelector('summary');
    if (!panel) {
      item.open = shouldOpen;
      return;
    }

    item._cdTargetOpen = shouldOpen;
    if (summary) summary.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

    var startHeight = item.open ? panel.getBoundingClientRect().height : 0;
    var startOpacity = item.open ? parseFloat(window.getComputedStyle(panel).opacity || '1') : 0;

    if (item._cdAccordionAnimation) {
      item._cdAccordionAnimation.onfinish = null;
      item._cdAccordionAnimation.oncancel = null;
      item._cdAccordionAnimation.cancel();
      item._cdAccordionAnimation = null;
    }

    if (shouldReduceMotion() || typeof panel.animate !== 'function') {
      item.open = shouldOpen;
      resetAccordionPanel(item, panel);
      return;
    }

    if (shouldOpen) {
      item.open = true;
      item.classList.remove('is-closing');
      item.classList.add('is-opening');
    } else {
      if (!item.open) {
        resetAccordionPanel(item, panel);
        return;
      }
      item.classList.remove('is-opening');
      item.classList.add('is-closing');
    }

    panel.style.height = 'auto';
    var endHeight = shouldOpen ? panel.scrollHeight : 0;
    panel.style.height = startHeight + 'px';
    panel.style.opacity = String(startOpacity);
    panel.style.overflow = 'hidden';

    var distance = Math.abs(endHeight - startHeight);
    var duration = shouldOpen
      ? clamp(300 + distance * 0.22, 340, 460)
      : clamp(240 + distance * 0.16, 280, 360);

    var animation = panel.animate(
      [
        { height: startHeight + 'px', opacity: startOpacity },
        { height: endHeight + 'px', opacity: shouldOpen ? 1 : 0 }
      ],
      {
        duration: duration,
        easing: shouldOpen
          ? 'cubic-bezier(0.22, 1, 0.36, 1)'
          : 'cubic-bezier(0.4, 0, 0.2, 1)',
        fill: 'forwards'
      }
    );

    item._cdAccordionAnimation = animation;

    animation.onfinish = function () {
      if (item._cdAccordionAnimation !== animation) return;
      item._cdAccordionAnimation = null;
      item.open = shouldOpen;
      resetAccordionPanel(item, panel);
    };
  }

  function bindFeatureControls(entry) {
    if (!entry || entry.featureControlsBound) return;
    entry.featureControlsBound = true;

    entry.featureDetails.forEach(function (item) {
      var summary = item.querySelector('summary');
      item._cdTargetOpen = item.open;
      if (summary) summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        var shouldOpen = !item._cdTargetOpen;
        if (shouldOpen) {
          entry.featureDetails.forEach(function (otherItem) {
            if (otherItem !== item && otherItem._cdTargetOpen) {
              setAccordionItemState(otherItem, false);
            }
          });
        }

        setAccordionItemState(item, shouldOpen);
      });
    });

    if (!entry.featureVideo) return;

    prepareFeatureVideo(entry);
    entry.featureVideo.addEventListener('play', function () {
      syncVideoControls(entry);
    });
    entry.featureVideo.addEventListener('pause', function () {
      syncVideoControls(entry);
    });
    entry.featureVideo.addEventListener('volumechange', function () {
      syncVideoControls(entry);
    });

    if (entry.playButton) {
      entry.playButton.addEventListener('click', function () {
        if (entry.featureVideo.paused) {
          entry.userPausedVideo = false;
          var playPromise = entry.featureVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
              syncVideoControls(entry);
            });
          }
        } else {
          entry.userPausedVideo = true;
          entry.featureVideo.pause();
        }
      });
    }

    if (entry.muteButton) {
      entry.muteButton.addEventListener('click', function () {
        entry.featureVideo.muted = !entry.featureVideo.muted;
      });
    }

    syncVideoControls(entry);
    playFeatureVideo(entry);
  }

  function updateFeatureAccessibility(entry, overallProgress, rect, viewportHeight) {
    if (!entry || !entry.featureLayer) return;

    var isAvailable =
      overallProgress > entry.ovalStart + 0.01 &&
      rect.bottom > 0 &&
      rect.top < viewportHeight;

    entry.featureLayer.setAttribute('aria-hidden', isAvailable ? 'false' : 'true');
    entry.featureLayer.toggleAttribute('inert', !isAvailable);

    if (isAvailable) playFeatureVideo(entry);
  }

  function getOrCreateEntry(section) {
    for (var i = 0; i < sections.length; i += 1) {
      if (sections[i].root === section) return sections[i];
    }

    var entry = {
      root: section,
      copyWrap: section.querySelector('[data-cd-pdp-statement-copy]'),
      uspItems: Array.prototype.slice.call(section.querySelectorAll('[data-cd-pdp-statement-usp]')),
      featureLayer: section.querySelector('[data-cd-pdp-feature-layer]'),
      featureDetails: Array.prototype.slice.call(
        section.querySelectorAll('[data-cd-pdp-feature-accordion] details')
      ),
      featureVideo: section.querySelector('[data-cd-pdp-feature-layer] video'),
      playButton: section.querySelector('[data-cd-pdp-video-play]'),
      muteButton: section.querySelector('[data-cd-pdp-video-mute]'),
      featureControlsBound: false,
      userPausedVideo: false,
      videoPrepared: false,
      lastHeaderScheme: null,
      lastHeaderForce: null,
      headerOverrideSource: 'pdp-statement-reveal-' + sections.length,
      ovalStart: parseFloat(section.getAttribute('data-cd-oval-start') || '0.12'),
      ovalEnd: parseFloat(section.getAttribute('data-cd-oval-end') || '0.32'),
      revealStart: parseFloat(section.getAttribute('data-cd-reveal-start') || '0.32'),
      revealEnd: parseFloat(section.getAttribute('data-cd-reveal-end') || '0.94'),
      headerSwitch: parseFloat(section.getAttribute('data-cd-header-switch') || '0.72')
    };

    buildLineflow(section);
    bindFeatureControls(entry);
    sections.push(entry);
    return entry;
  }

  function getRevealSizes() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    var isMobile = width <= 1024;
    var maxRadius = Math.sqrt(width * width + height * height) * 1.15;
    var baseWidth = isMobile ? Math.min(width * 0.8534, 320) : Math.min(width * 0.435, 612);
    var baseHeight = isMobile ? baseWidth * (448 / 320) : baseWidth * (768 / 592);

    return {
      baseRx: baseWidth / 2,
      baseRy: baseHeight / 2,
      maxRx: maxRadius,
      maxRy: maxRadius
    };
  }

  function getHeaderTouchLine() {
    var header =
      document.querySelector('.cd-hero-header__wrapper') ||
      document.querySelector('[data-cd-hero-header]') ||
      document.querySelector('#shopify-section-header-inline') ||
      document.querySelector('header');

    if (!header) return Math.min(window.innerHeight, 96);

    var rect = header.getBoundingClientRect();
    if (!rect || rect.height <= 0) return Math.min(window.innerHeight, 96);

    return clamp(rect.bottom, 0, window.innerHeight);
  }

  function setHeaderForce(entry, scheme) {
    if (!entry || !entry.root) return;

    var nextScheme = scheme || null;
    if (nextScheme === entry.lastHeaderForce) return;

    entry.lastHeaderForce = nextScheme;

    if (nextScheme) {
      document.documentElement.setAttribute('data-cd-pdp-header-force-scheme', nextScheme);
    } else if (
      document.documentElement.getAttribute('data-cd-pdp-header-force-scheme') === 'dark'
    ) {
      document.documentElement.removeAttribute('data-cd-pdp-header-force-scheme');
    }

    if (
      window.CDCleerPdpHeaderScheme &&
      typeof window.CDCleerPdpHeaderScheme.set === 'function'
    ) {
      window.CDCleerPdpHeaderScheme.set(entry.headerOverrideSource, nextScheme);
    } else if (
      window.CDCleerPdpSurfaceBlend &&
      typeof window.CDCleerPdpSurfaceBlend.update === 'function'
    ) {
      window.CDCleerPdpSurfaceBlend.update();
    }

    if (
      window.CDCleerHeaderTheme &&
      typeof window.CDCleerHeaderTheme.refresh === 'function'
    ) {
      window.CDCleerHeaderTheme.refresh();
    }
  }

  function setHeaderScheme(entry, overallProgress, rect, viewportHeight, radiusY, clipProgress) {
    if (!entry || !entry.root) return;

    var scheme = 'light';

    if (scheme !== entry.lastHeaderScheme) {
      entry.lastHeaderScheme = scheme;
      entry.root.setAttribute('data-cd-header-scheme', scheme);
      entry.root.setAttribute('data-cd-header-scheme-mobile', scheme);
      entry.root.setAttribute('data-cd-pdp-statement-header-touch', 'false');
    }

    setHeaderForce(entry, null);
  }

  function updateUSPItems(entry, overallProgress) {
    if (!entry || !entry.uspItems) return;

    if (shouldReduceMotion()) {
      entry.uspItems.forEach(markVisible);
      return;
    }

    entry.uspItems.forEach(function (node) {
      var step = parseFloat(node.getAttribute('data-cd-pdp-usp-step') || '0');
      var threshold = 0.03 + (step * 0.03);
      if (overallProgress >= threshold) markVisible(node);
    });
  }

  function updateEntry(entry) {
    if (!entry || !entry.root) return;

    var rect = entry.root.getBoundingClientRect();
    var viewportHeight = window.innerHeight;
    var travel = Math.max(entry.root.offsetHeight - viewportHeight, 1);
    var overallProgress = clamp((-rect.top) / travel, 0, 1);
    var sizes = getRevealSizes();

    if (shouldReduceMotion()) {
      entry.root.style.setProperty('--cd-pdp-statement-content-opacity', '0');
      entry.root.style.setProperty('--cd-pdp-statement-content-y', '-24px');
      entry.root.style.setProperty('--cd-pdp-statement-clip-rx', '200vmax');
      entry.root.style.setProperty('--cd-pdp-statement-clip-ry', '200vmax');
      markVisible(entry.copyWrap);
      updateUSPItems(entry, 1);
      updateFeatureAccessibility(entry, 1, rect, viewportHeight);
      setHeaderScheme(entry, 1, rect, viewportHeight, viewportHeight, 1);
      return;
    }

    var clipProgress = clamp(
      (overallProgress - entry.ovalStart) / Math.max(entry.revealEnd - entry.ovalStart, 0.01),
      0,
      1
    );
    var introPhase = 0.22;
    var rx = 0;
    var ry = 0;

    if (clipProgress > 0 && clipProgress < introPhase) {
      var introProgress = easeInOutCubic(clipProgress / introPhase);
      rx = sizes.baseRx * introProgress;
      ry = sizes.baseRy * introProgress;
    } else if (clipProgress >= introPhase) {
      var expandProgress = easeInOutCubic((clipProgress - introPhase) / (1 - introPhase));
      rx = sizes.baseRx + (sizes.maxRx - sizes.baseRx) * expandProgress;
      ry = sizes.baseRy + (sizes.maxRy - sizes.baseRy) * expandProgress;
    }

    var textFadeStart = Math.max(entry.revealStart - 0.05, entry.ovalStart + 0.08);
    var textFadeEnd = Math.min(entry.revealStart + 0.18, entry.revealEnd);
    var contentFade = clamp(
      (overallProgress - textFadeStart) / Math.max(textFadeEnd - textFadeStart, 0.01),
      0,
      1
    );
    var contentOpacity = 1 - easeInOutCubic(contentFade);
    var contentY = -24 * easeOutCubic(contentFade);

    entry.root.style.setProperty('--cd-pdp-statement-content-opacity', contentOpacity.toFixed(4));
    entry.root.style.setProperty('--cd-pdp-statement-content-y', contentY.toFixed(2) + 'px');
    entry.root.style.setProperty('--cd-pdp-statement-clip-rx', rx.toFixed(2) + 'px');
    entry.root.style.setProperty('--cd-pdp-statement-clip-ry', ry.toFixed(2) + 'px');

    if (rect.top < viewportHeight * 0.86 && rect.bottom > viewportHeight * 0.18) {
      markVisible(entry.copyWrap);
    }

    updateUSPItems(entry, overallProgress);
    updateFeatureAccessibility(entry, overallProgress, rect, viewportHeight);
    setHeaderScheme(entry, overallProgress, rect, viewportHeight, ry, clipProgress);
  }

  function updateAll() {
    sections.forEach(updateEntry);
    ticking = false;
  }

  function queueUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAll);
  }

  function initAll(context) {
    var scope = context || document;
    var nodes = scope.querySelectorAll('[data-cd-pdp-statement-reveal]');
    nodes.forEach(getOrCreateEntry);
    queueUpdate();
  }

  function rebuildAll() {
    sections.forEach(function (entry) {
      if (!entry || !entry.root) return;
      buildLineflow(entry.root);
    });
    queueUpdate();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  window.addEventListener('load', function () {
    initAll(document);
    rebuildAll();
  });

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', function () {
    clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuildAll, 140);
    queueUpdate();
  });
  window.addEventListener('orientationchange', function () {
    clearTimeout(rebuildTimer);
    rebuildTimer = window.setTimeout(rebuildAll, 140);
    queueUpdate();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
    rebuildAll();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    sections.forEach(playFeatureVideo);
  });

  if (
    prefersReducedMotion &&
    typeof prefersReducedMotion.addEventListener === 'function'
  ) {
    prefersReducedMotion.addEventListener('change', function () {
      rebuildAll();
    });
  }
})();
